@if (!customTrigger) {
  <div class="select-trigger-container" [class.select-disabled]="disabled || readonly" [class.select-readonly]="readonly" #triggerContainer
    [matMenuTriggerFor]="selectMenu" (menuOpened)="onOpen()">
    <ng-content select="[select-trigger], app-select-trigger"></ng-content>
  </div>
}
@if (customTrigger) {
  <div class="select-trigger-container" [class.select-disabled]="disabled || readonly" [class.select-readonly]="readonly" #triggerContainer
    [matMenuTriggerFor]="selectMenu" (menuOpened)="onOpen()">
    <ng-content select="[custom-trigger]"></ng-content>
  </div>
}
<mat-menu #selectMenu class="mat-menu-custom"
  [xPosition]="xPosition" yPosition="below"
  (click)="$event.stopPropagation()"
  (closed)="onClose()">
  <div class="flex-column pad-S-0 multi-select-panel" [style.width.px]="width || 300" [class.gap-S]="selectInsert() || selectSearch()"
    (click)="$event.stopPropagation()">
    <div class="select-search-container" [class.select-disabled]="loading || disabled || readonly">
      <div class="flex gap-S">
        <div style="flex: 1">
          <ng-content select="[select-search], app-select-search"></ng-content>
        </div>
        @if (enableDeleteMode && canDelete && !isEmpty && !isDeleteMode) {
          <div style="padding: 3px;" class="flex-align-center filter-bar bkg-white b-radius-6">
            <app-text-button style="width: 35px; height: 35px;" type="default" color="primary"
              panelClass="h-100-imp pad-0-imp"
              [matMenuTriggerFor]="deleteMenu"
              #menuTriggerRef="matMenuTrigger"
              [disabled]="loading || disabled || readonly"
              [loading]="loading">
              <div class="flex-center">
                <img src="assets/icons/dots-vertical.svg" height="18" alt=""/>
              </div>
            </app-text-button>
            <mat-menu #deleteMenu class="mat-menu-delete"
              xPosition="before" yPosition="below">
              <div style="padding: 6px;">
                <div (click)="toggleDeleteModeAndCloseMenu($event); $event.stopPropagation();" class="flex-align-center gap-S b-radius-6 c-p multi-select-delete-button" style="padding: 5px 10px">
                  <img src="assets/icons/trash-03.svg" width="18" class="filter-white" height="18" alt=""/>
                  <div class="font-M fw-500 white">{{ 'global.multiSelect.delete.deleteElements' | translate }}</div>
                </div>
              </div>
            </mat-menu>
          </div>
        }
        @if (enableDeleteMode && canDelete && !isEmpty && isDeleteMode) {
          <div style="width: 41px; height: 41px;">
            <app-text-button type="stroked" color="accent"
              panelClass="h-100-imp pad-0-imp"
              (click)="toggleDeleteModeAndCloseMenu($event);"
              [tooltip]="'global.multiSelect.delete.cancel' | translate"
              tooltipPosition="right"
              [disabled]="loading || disabled || readonly"
              [loading]="loading">
              <div class="flex-center">
                <img src="assets/icons/cross-black.svg" height="18" alt=""/>
              </div>
            </app-text-button>
          </div>
        }
      </div>
    </div>
    @if (!isDeleteMode) {
      <div class="select-insert-container" [class.select-disabled]="loading || disabled">
        <ng-content select="[select-insert], app-select-insert"></ng-content>
      </div>
    }
    @if (!loading && !iconSelection) {
      <div
        class="flex-column select-option-container"
        #optionContainer
        [style.max-height.px]="insertOpened && !confirmButton ? 167.6 : insertOpened && confirmButton ? 206 : 255"
        [style.min-height.px]="addMinHeight ? insertOpened && !confirmButton ? 167.6 : insertOpened && confirmButton ? 206 : 255 : undefined"
        (scroll)="onScroll($event)"
        [class.select-disabled]="disabled || readonly" [class.mr-s]="hasScroll()" [class.select-option-container-empty]="isEmpty">
        <ng-content select="app-select-option"></ng-content>
        <ng-content select="app-select-option-group"></ng-content>
        @if (isEmpty && !selectSearch()?.searchControl?.value) {
          <div [style.height.px]="addMinHeight ? 255 : undefined" class="h-100 flex-center flex-column gap-L">
            <span class="font-M fw-500 grey text-center" style="max-width: 244px">{{emptyPlaceholder|translate}}</span>
          </div>
        }
        @if (isEmpty && selectSearch()?.searchControl?.value) {
          <div [style.height.px]="addMinHeight ? 255 : undefined" class="h-100 flex-center flex-column gap-L">
            <span class="font-M fw-500 grey text-center" style="max-width: 244px">{{emptyPlaceHolderWithSearch|translate}}</span>
          </div>
        }
      </div>
    }
    @if (!loading && iconSelection) {
      <div
        class="flex gap-XS"
        [class.select-disabled]="disabled || readonly" [class.mr-s]="hasScroll()">
        <ng-content select="app-select-option"></ng-content>
        <ng-content select="app-select-option-group"></ng-content>
        @if (isEmpty && selectSearch()?.searchControl?.value) {
          <div [style.height.px]="addMinHeight ? 255 : undefined" class="h-100 flex-center flex-column gap-L">
            <span class="font-M fw-500 grey text-center" style="max-width: 244px">{{emptyPlaceHolderWithSearch|translate}}</span>
          </div>
        }
      </div>
    }
    @if (!loading && isDeleteMode) {
      <div class="flex-center pad-S-S-0 border-light-grey-top">
        <app-text-button
          color="warn"
          type="flat"
          class="w-100"
          [disabled]="itemsForDeletion.length === 0"
          (click)="confirmDelete()">
          {{ 'global.multiSelect.delete.1' | translate }} {{ itemsForDeletion.length }} {{ 'global.multiSelect.delete.2' | translate }}
        </app-text-button>
      </div>
    }
    @if (loading) {
      <div class="flex-center select-loader-container" [class.select-disabled]="disabled || readonly">
        <mat-spinner color="accent" [diameter]="16"></mat-spinner>
      </div>
    }
    @if (!loading && multiple && confirmButton && !isDeleteMode) {
      <div class="flex-center pad-S-S-0 border-light-grey-top">
        <app-text-button type="flat" class="w-100" (click)="onConfirm()">{{'Appliquer'}}</app-text-button>
      </div>
    }
  </div>
</mat-menu>
